export default __webpack_public_path__ + "static/media/Rectangle 240.f11102bc.svg";